<template>
  <v-dialog v-model="show" width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>

      <v-card-text
        v-for="msg in messages"
        :key="msg.blNo"
        style="margin: 10px 20px 10px 20px"
        >{{ 'containerNo:' + msg.blNo + ' : ' + msg.errors }}</v-card-text
      >
      <v-card-actions class="justify-center">
        <v-btn @click="confirm">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    width: '',
    title: '',
    message: '',
    show: false,
    messages: [],
  }),
  methods: {
    popup(title, messages) {
      this.show = true
      this.messages = messages
      this.title = title
    },
    confirm() {
      this.show = false
    },
  },
}
</script>
